module.exports = __webpack_public_path__ + "static/media/sees_emblem_gold.f853a808.png";